import DeleteModalSecondary from '@/components/Modals/DeleteModalSecondary';
import { useRefetchAgents, useUpdateAgent } from '@/pages/agents/api';
import { useAnalytics } from '@/services/analytics';
import { IAgent } from '@d-id/types';

interface Props {
    itemToDelete: IAgent | null;
    onClose: () => void;
}

export const DeleteEmbedAgentModal = ({ itemToDelete, onClose }: Props) => {
    const mixpanel = useAnalytics();
    const { mutateAsync: updateAgentMutation } = useUpdateAgent();
    const { refetchAgents } = useRefetchAgents();

    const onItemRemoveEmbed = async () => {
        if (itemToDelete) {
            mixpanel?.track('agent-remove-embed', {
                event: 'click',
                from: 'library',
                agentId: itemToDelete.id,
            });

            await updateAgentMutation({ agentId: itemToDelete.id, update: { embed: false } });
            await refetchAgents();

            onClose();
        }
    };

    return (
        <DeleteModalSecondary
            itemType="agent"
            mode="square"
            open={!!itemToDelete}
            isLoading={false}
            onDelete={onItemRemoveEmbed}
            onClose={onClose}
            poster={itemToDelete?.preview_thumbnail ?? itemToDelete?.presenter?.thumbnail ?? ''}
            text={{
                title: 'Are you sure?',
                content: 'Removing the embed will disable access to your agent on your website',
                cta: 'Remove embed',
            }}
        />
    );
};
